import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { AppDispatch, RootState } from '../store'
import { Screens } from 'patient-api-lib'

type MyBookingsState = {
  jwt: string | null
}

export const initialState: MyBookingsState = {
  jwt: null,
}

export const done = createAsyncThunk<
  Screens,
  void,
  { dispatch: AppDispatch; state: RootState }
>('myBookingsScreen/done', async () => {
  return Screens.YourBookingsScreen
})

export const MyBookingsScreen = createSlice({
  name: 'myBookingsScreen',
  initialState,
  reducers: {
    setJwt: (state, action: PayloadAction<string>) => {
      state.jwt = action.payload
    },
  },
})

export const { setJwt } = MyBookingsScreen.actions

export default MyBookingsScreen.reducer
